import React from 'react';
import RadioPage from '@domain/pages/RadioPage';

const customerGender = 'customerGender';
function GenderCompleteOptions() {

  const fields = [{
    id: 1,
    value: 'male',
    triggerKeys: [77, 109, 49],
    label: 'Man'
  }, {
    id: 2,
    value: 'female',
    triggerKeys: [86, 118, 50],
    label: 'Vrouw'
  },
  {
    id: 3,
    value: 'other',
    triggerKeys: [],
    label: 'Geen voorkeur'
  }
  ]

  return <RadioPage fieldName={customerGender} styleLabel={'gender'} fields={fields} className={'more-opts'} />
}

export default GenderCompleteOptions;